import { render, staticRenderFns } from "./FilialTabela.vue?vue&type=template&id=a59d2f26&scoped=true&lang=html"
import script from "./FilialTabela.vue?vue&type=script&lang=js"
export * from "./FilialTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59d2f26",
  null
  
)

export default component.exports